<template>
  <div id="app">
    <router-view v-if="isRouterAlive" />
  </div>
</template>
<script>

export default {
  name: 'App',
  provide () {
    // 父组件中通过provide来提供变量，在子组件中通过inject来注入变量。
    return {
      reload: this.reload
    }
  },
  data () {
    return {
      isRouterAlive: true // 控制视图是否显示的变量
    }
  },
  mounted () {
    this.setRemUnit()
    window.addEventListener('resize', this.setRemUnit)
    const userInfo = JSON.parse(localStorage.getItem('kzcUserInfo'))
    this.changeTitle(userInfo.company_name)
  },
  methods: {
    changeTitle (newTitle) {
      document.title = newTitle || ''
    },
    reload () {
      this.isRouterAlive = false // 先关闭，
      this.$nextTick(function () {
        this.isRouterAlive = true // 再打开
      })
      console.log('reload')
    },
    // rem 设置根节点字体大小
    setRemUnit () {
      const docEl = document.documentElement
      const clientWidth = docEl.clientWidth
      if (!clientWidth) return
      docEl.style.fontSize = 10 * (clientWidth / 1920) + 'px'
      // console.log('font-size', docEl.style.fontSize)
    }
  }
}
</script>
<style>
html,
body {
  width: 100%;
  height: 100%;
  overflow: hidden;
  margin: 0;
  padding: 0;
}
#app {
  width: 100%;
  height: 100%;
}
.el-radio__original {
  display: none !important; /* 隐藏原生 radio 输入，但仍然允许交互 */
}
</style>
